module.exports = __webpack_public_path__ + "static/images/cart-empty.732797c.png";